<div class="page gray-font-color font-family bodyBackground residence-history">
  <div class="header-navigation-back">
    <mat-icon (click)="goBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">Add Previous Address</span>
  </div>
  <div class="form-content">
  @if (!isContentReady) {
    <app-skeleton-emp-residence-history
      isResidenceHistory="true"
    ></app-skeleton-emp-residence-history>
  }
  @if (isContentReady) {
    <div class="address-fields" [formGroup]="previousAddressForm">
      <div>
        <div class="form-field-container">
          <mat-checkbox
            [checked]="turnOffAddressLookup"
            (change)="onAddressLookupCheckboxToggle($event)"
            data-testid="google-address-lookup-toggle">
            Enter address from outside Canada or USA:
          </mat-checkbox>
        </div>
        @if (!turnOffAddressLookup) {
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline" data-testid="address">
              <mat-label>ADDRESS</mat-label>
              <input matInput id="previousAddressText" formControlName="fullAddress" #previousAddressText />
              @if (previousAddressForm.get('fullAddress')?.touched && previousAddressForm.get('fullAddress')?.invalid) {
                <mat-error>
                  {{ getFullAddressErrorMessage() }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        } @else {
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>ADDRESS</mat-label>
              <input matInput formControlName="previousAddress" />
              @if (previousAddressForm.get('previousAddress')?.touched && previousAddressForm.get('previousAddress')?.invalid) {
                <mat-error>
                  {{ getPreviousAddressErrorMessage() }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>COUNTRY</mat-label>
              <mat-select formControlName="previousAddressCountry" (selectionChange)="onCountryChange()">
                <mat-option *ngFor="let country of countries" [value]="country.value">
                  {{ country.key }}
                </mat-option>
              </mat-select>
              @if (previousAddressForm.get('previousAddressCountry')?.touched && previousAddressForm.get('previousAddressCountry')?.invalid) {
                <mat-error>
                  {{ getPreviousAddressCountryErrorMessage() }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>STATE / PROVINCE</mat-label>
              @if (provinces.length) {
                <mat-select formControlName="previousAddressState">
                  <mat-option value="">Select province</mat-option>
                  <mat-option *ngFor="let province of provinces" [value]="province.value">
                    {{ province.name }}
                  </mat-option>
                </mat-select>
              } @else {
                <input matInput formControlName="previousAddressState" />
              }
              @if (previousAddressForm.get('previousAddressState')?.touched && previousAddressForm.get('previousAddressState')?.invalid) {
                <mat-error>
                  {{ getPreviousAddressStateErrorMessage() }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>CITY</mat-label>
              <input matInput formControlName="previousAddressCity" />
              @if (previousAddressForm.get('previousAddressCity')?.touched && previousAddressForm.get('previousAddressCity')?.invalid) {
                <mat-error>
                  {{ getPreviousAddressCityErrorMessage() }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>ZIPCODE / POSTAL CODE</mat-label>
              <input matInput formControlName="previousAddressZipCode" />
              @if (previousAddressForm.get('previousAddressZipCode')?.touched && previousAddressForm.get('previousAddressZipCode')?.invalid) {
                <mat-error>
                  {{ getPreviousAddressZipCodeErrorMessage() }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      <!-- Date Selection with Month/Year Dropdowns -->
      @if (getDateConstraintMessage()) {
        <div class="constraint-message">
          <mat-icon>info</mat-icon>
          <span>{{ getDateConstraintMessage() }}</span>
        </div>
      }
      @if (minFromDate) {
        <div class="form-field-container">
          <div class="date-selector-row">
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>FROM MONTH</mat-label>
              <mat-select formControlName="previousFromMonth" data-testid="previous-from-month">
                @for (month of getAvailableFromMonths(); track month) {
                  <mat-option [value]="month.value">
                    {{ month.name }}
                  </mat-option>
                }
              </mat-select>
              @if (previousAddressForm.get('previousFromMonth')?.touched && previousAddressForm.get('previousFromMonth')?.invalid) {
                <mat-error>
                  Month is required
                </mat-error>
              }
            </mat-form-field>
            
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>FROM YEAR</mat-label>
              <mat-select formControlName="previousFromYear" data-testid="previous-from-year">
                @for (year of getAvailableFromYears(); track year) {
                  <mat-option [value]="year">
                    {{ year }}
                  </mat-option>
                }
              </mat-select>
              @if (previousAddressForm.get('previousFromYear')?.touched && previousAddressForm.get('previousFromYear')?.invalid) {
                <mat-error>
                  Year is required
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
      @if (maxFromDate) {
        <div class="form-field-container">
          <div class="date-selector-row">
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>TO MONTH</mat-label>
              <mat-select formControlName="previousToMonth" data-testid="previous-to-month">
                @for (month of getAvailableToMonths(); track month) {
                  <mat-option [value]="month.value">
                    {{ month.name }}
                  </mat-option>
                }
              </mat-select>
              @if (previousAddressForm.get('previousToMonth')?.touched && previousAddressForm.get('previousToMonth')?.invalid) {
                <mat-error>
                  Month is required
                </mat-error>
              }
            </mat-form-field>
            
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>TO YEAR</mat-label>
              <mat-select formControlName="previousToYear" data-testid="previous-to-year">
                @for (year of getAvailableToYears(); track year) {
                  <mat-option [value]="year">
                    {{ year }}
                  </mat-option>
                }
              </mat-select>
              @if (previousAddressForm.get('previousToYear')?.touched && previousAddressForm.get('previousToYear')?.invalid) {
                <mat-error>
                  Year is required
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
</div>
}
  </div>
<div class="fixed-footer">
  <button mat-button class="btn-cancel" (click)="navigateToListPage()" [disabled]="!isContentReady">Cancel</button>
  <button
    mat-raised-button
    class="btn-save margin-right-sm"
    (click)="onSubmit()"
    [disabled]="!previousAddressForm.valid || !isContentReady"
    data-test="save-button"

    >
    Save
  </button>
</div>
</div>
